import { custom } from 'utils/Api';

import {
  REQUEST_UNION,
  REQUEST_UNION_FAILURE,
  REQUEST_UNION_SUCCESS,
  REQUEST_EMPLOYEE_UNION,
  REQUEST_EMPLOYEE_UNION_FAILURE,
  REQUEST_EMPLOYEE_UNION_SUCCESS,
  REQUEST_PENSION,
  REQUEST_PENSION_FAILURE,
  REQUEST_PENSION_SUCCESS,
} from 'constants/ActionTypes';

const requestUnion = () => ({
  type: REQUEST_UNION,
});

const requestUnionSuccess = unions => ({
  type: REQUEST_UNION_SUCCESS,
  unions,
});

const requestUnionFailure = error => ({
  type: REQUEST_UNION_FAILURE,
  error,
});

export const fetchUnionData = employeeDetailId =>
  (dispatch, getState) => {
    dispatch(requestUnion());
    const {
      loginReducer: { user: { token } },
    } = getState();

    const config = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      url: `/kjarni/api/v2/EmployeeDetailUnions(${employeeDetailId})/PayUnionDetail`,
    };

    return custom(config)
      .then(({ data }) => {
        dispatch(requestUnionSuccess(data.value));
      })
      .catch(err => dispatch(requestUnionFailure(err)));
  };

const requestEmployeeUnion = () => ({
  type: REQUEST_EMPLOYEE_UNION,
});

const requestEmployeeUnionSuccess = employeeUnions => ({
  type: REQUEST_EMPLOYEE_UNION_SUCCESS,
  employeeUnions,
});

const requestEmployeeUnionFailure = error => ({
  type: REQUEST_EMPLOYEE_UNION_FAILURE,
  error,
});

export const fetchEmployeeUnionData = employeeDetailId =>
  (dispatch, getState) => {
    dispatch(requestEmployeeUnion());
    const {
      loginReducer: { user: { token } },
    } = getState();

    const config = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      url: `/kjarni/api/v2/EmployeeDetailUnions(${employeeDetailId})/EmployeeUnionDetail`,
    };

    return custom(config)
      .then(({ data }) => {
        dispatch(requestEmployeeUnionSuccess(data.value));
      })
      .catch(err => dispatch(requestEmployeeUnionFailure(err)));
  };

const requestPension = () => ({
  type: REQUEST_PENSION,
});

const requestPensionSuccess = data => ({
  type: REQUEST_PENSION_SUCCESS,
  data,
});

const requestPensionFailure = error => ({
  type: REQUEST_PENSION_FAILURE,
  error,
});

export const fetchPensionData = employeeDetailId =>
  (dispatch, getState) => {
    dispatch(requestPension());
    const {
      loginReducer: { user: { token } },
    } = getState();

    const config = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      url: `/kjarni/api/v2/EmployeeDetailPensions(${employeeDetailId})/PensionDetail`,
    };

    return custom(config)
      .then(({ data }) => {
        dispatch(requestPensionSuccess(data));
      })
      .catch(err => dispatch(requestPensionFailure(err)));
  };



// WEBPACK FOOTER //
// ./src/actions/EmployeePensionAndUnion.js